import { useState } from 'react';
import { TimePicker } from 'antd';
import type { TimePickerProps } from 'antd/es/time-picker';
import type { Dayjs } from 'dayjs';
import { t } from 'i18next';
import type { TComponent } from 'utils/types/component';

import styles from './TimePickerWithHint.module.scss';

interface ITimePickerWithHintProps extends TimePickerProps {
    hint?: string;
}

export const TimePickerWithHint: TComponent<ITimePickerWithHintProps> = (
    props,
) => {
    const { hint = 'common.form.timePickerHint', ...other } = props;

    const [hasTimeValue, setHasTimeValue] = useState(false);

    const handleChange = (value: Dayjs, dateString: string | string[]) => {
        setHasTimeValue(!!value);

        if (!other?.onChange) {
            return;
        }

        other.onChange(value, dateString);
    };

    return (
        <div className={styles.timePickerContainer}>
            <TimePicker
                format='HH:mm'
                className={styles.input}
                {...other}
                onChange={handleChange}
            />
            {hasTimeValue && (
                <div className={styles.timePickerHint}>{t(hint)}</div>
            )}
        </div>
    );
};
